var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.worksheet.id)?_c('WorksheetAppliedLessons',{attrs:{"id":_vm.worksheet.id,"type":_vm.type,"onlyPR":_vm.onlyPR,"highlight":_vm.highlight}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }